import { SET_GUEST_BULK_WASTE_CLASSIFICATION_UNACCEPTED_ITEMS } from "constants-lib/actionTypes"

export const setBulkWasteClassificationUnacceptedItems =
  (data) => (dispatch) => {
    dispatch({
      type: SET_GUEST_BULK_WASTE_CLASSIFICATION_UNACCEPTED_ITEMS,
      payload: data,
    })
  }
